import { useInfiniteQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
interface IUseFetchTransactionTypesList {
  relations?: string[];
  sortBy?: string[];
  extraFilters?: Record<string, string | number | boolean>;
  pageSize?: number;
  hasLinkedTransactionTypes?: boolean;
  matterId?: string;
  search?: string;
  fields?: string[];
}
export const useFetchTransactionTypesList = (params: IUseFetchTransactionTypesList) => {
  const fetchTransactionTypes = async ({ pageParam = 1 }) => {
    const {
      relations: typesRelations,
      extraFilters: filters,
      hasLinkedTransactionTypes,
      matterId,
      pageSize,
      ...rest
    } = params;
    const queryString = new URLSearchParams(
      Object.keys(rest)?.length ? toQueryString(rest as QueryParamObject) : '',
    );

    Object.entries(filters ?? {}).forEach(([key, value]) => {
      queryString.append(`filter.${key}`, String(value));
    });

    (typesRelations ?? []).forEach((rel) => queryString.append('relations', rel));

    queryString.append('page', String(pageParam));
    queryString.append('limit', String(pageSize));
    try {
      if (hasLinkedTransactionTypes) {
        return await get(
          `${API_URLS.MATTERS_LIST}/${matterId}${API_URLS.TRANSACTION_TYPES}?${queryString.toString()}`,
        );
      } else {
        return await get(`${API_URLS.TRANSACTION_TYPES}?${queryString.toString()}`);
      }
    } catch (error) {
      console.error('Error fetching transactions types:', error);
      throw new Error(
        (error as { message: string }).message || 'Failed to fetch transaction types',
      ); // Force error throwing
    }
  };

  const {
    data,
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  } = useInfiniteQuery({
    initialPageParam: 1,
    queryKey: ['transaction-types-list', params],
    queryFn: fetchTransactionTypes,
    getNextPageParam: (lastPage, allPages) => {
      const totalCount = lastPage?.meta?.totalItems ?? 0;
      const fetchedCount = allPages.flatMap((page) => page.data).length;
      return fetchedCount < totalCount ? allPages.length + 1 : undefined;
    },
  });
  return {
    data: data?.pages.flatMap((page) => page.data) ?? [],
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  };
};
